import React from 'react';
import './shimmer.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Skeleton } from 'primereact/skeleton';

export default function ShimmerSearch() {
  return (
    <>
      {/* {Array.from({ length: 5 }).map((el, i) => {
        return <div className="shimmer-search"></div>;
      })} */}
      <Skeleton height="2rem" className="mb-2"></Skeleton>
    </>
  );
}
